module.exports = __webpack_public_path__ + "static/process3-81858983ccf9b9ded4382dd6f3eee7aa.png";